import React, { useState } from 'react';
import { Modal, Center, Text, Button, Radio, TextArea, Box, Flex, useTheme } from 'native-base';
import { useAuthState } from '../../../context/auth';
import { useEnvState } from '../../../context/env';
import { useTopicsDispatch, topicsAPI } from '../../../context/topics';
import { POST_ACTION_TYPES } from '../../Constants';
import { checkFlagged } from '../../utils/helpers';
import { LANGUAGES, FLAG_POST_REASON_MIN_LENGTH } from '../../Constants';
const FlagPost = ({
  type,
  topic,
  reply,
  showFlagModal,
  setShowFlagModal,
  updateTopicReplies
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const [postActionTypeId, setPostActionTypeId] = useState(null);
  const [reasonTextForFlagging, setReasonTextForFlagging] = useState('');
  const isInputTextValid = reasonTextForFlagging.length >= FLAG_POST_REASON_MIN_LENGTH; // 10
  const authState = useAuthState();
  const envState = useEnvState();
  const topicsDispatch = useTopicsDispatch();
  const isPostActionTypeSomethingElse = postActionTypeId === 7;

  /*
  post_action_type_id
  off-topic: 3
  inappropriate: 4
  something else: 7 => requires {message} field
  spam: 8
  */

  const flagPost = async () => {
    const myAction = checkFlagged(reply); // action object or false
    if (!myAction) {
      const postId = reply === null || reply === void 0 ? void 0 : reply.id;
      if (postId && postActionTypeId) {
        const data = {
          id: postId,
          post_action_type_id: postActionTypeId,
          flag_topic: false // make replies flaggable only
        };
        if (isPostActionTypeSomethingElse) {
          data.message = reasonTextForFlagging;
        }
        const res = await topicsAPI.flagPost(envState.base_url, authState.api_key, postId, data);
        if (res && res.actions_summary && res.actions_summary.length > 0) {
          const action = res.actions_summary[0]; // only one item exists
          if (action && action.acted) {
            setPostActionTypeId(null);
            setReasonTextForFlagging('');
            setShowFlagModal(false);
            topicsDispatch({
              type: 'SET_FLAGGED_POST_ID',
              payload: null
            });
            topicsDispatch({
              type: 'SET_FLAGGED_POST_ID',
              payload: res.id
            });
            updateTopicReplies && updateTopicReplies(res.topic_id);
            return true;
          }
        }
      }
    }
    // if flagged already, <FlaggedAlready /> modal will pop up

    throw new Error('Invalid post id or selection');
  };
  const handleOnChange = e => {
    setReasonTextForFlagging(e.nativeEvent.text);
  };
  return /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(Modal, {
    isOpen: showFlagModal,
    onClose: () => setShowFlagModal(false)
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Modal.CloseButton, null), /*#__PURE__*/React.createElement(Modal.Header, null, "Flag post"), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Radio.Group, {
    value: postActionTypeId,
    onChange: nextValue => setPostActionTypeId(nextValue)
  }, POST_ACTION_TYPES && POST_ACTION_TYPES.map(actionType => /*#__PURE__*/React.createElement(Radio, {
    key: actionType.name,
    value: actionType.value
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: 'column'
  }, /*#__PURE__*/React.createElement(Box, {
    my: 2,
    ml: 2
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: 'semibold'
  }, actionType.name), /*#__PURE__*/React.createElement(Text, {
    fontSize: 'xs'
  }, actionType.description)))))), isPostActionTypeSomethingElse && /*#__PURE__*/React.createElement(TextArea, {
    placeholder: LANGUAGES.PLACEHOLDERS.FLAG_POST,
    value: reasonTextForFlagging,
    onChange: handleOnChange
  }), isPostActionTypeSomethingElse && !isInputTextValid && /*#__PURE__*/React.createElement(Text, {
    fontSize: 'xs',
    color: colors.flagPost.message
  }, "Please enter at least ", FLAG_POST_REASON_MIN_LENGTH, " characters.")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button.Group, null, /*#__PURE__*/React.createElement(Button, {
    variant: 'ghost',
    colorScheme: 'blueGray',
    onPress: () => setShowFlagModal(false)
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onPress: flagPost,
    isDisabled: isPostActionTypeSomethingElse && !isInputTextValid
  }, "Flag this post"))))));
};
export default FlagPost;
//# sourceMappingURL=FlagPost.js.map